<template>
	<div class="main_wrap unit">
		<NavTab />
		<div class="search-box">
			<form @submit.prevent="getUnitList">
				<div class="select-wrap">
					<div class="group margin-right-15">
						<span class="left">单位名称</span>
						<div class="right">
							<input type="text" placeholder="请输入单位名称" v-model.trim="model.organizationName" />
						</div>
					</div>
					<div class="group situation margin-right-15 searchArrow">
						<span class="left">所属区域</span>
						<div class="right">
						<el-select placeholder="请选择" v-model="provinceCode">
							<el-option v-for="item in provinceList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" ></el-option>
						</el-select>
						<el-select placeholder="请选择" v-model="cityCode" @change="onSelectCity">
							<el-option v-for="item in cityList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" ></el-option>
						</el-select>
						<el-select placeholder="请选择" class="" v-model="model.areaId">
							<el-option v-for="item in areaList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" ></el-option>
						</el-select>
						</div>
					</div>
					<div class="group btn-box">
						<button type="submit" class="btn margin-left-0">搜索</button>
						<button type="button" @click="detailBox" class="btn">新增</button>
						<button type="button" @click="deleteConfirm(deleteId)" class="btn">删除</button>
					</div>
				</div>
			</form>
		</div>
		<div class="table_wrap">
			<div class="table_layout">
				<div class="table_scroll">
					<el-table
						:data="dataTabel"
						max-height="534"
						border
						:cell-style="cellStyle"
						style="width: 100%"
						:header-cell-style="tableHeaderColor"
						@selection-change="handleSelectionChange"
					>
						<el-table-column type="selection" width="60"></el-table-column>
						<el-table-column label="单位名称" prop="fullName" min-width="100" show-overflow-tooltip ></el-table-column>
						<el-table-column label="简称" prop="simpName" min-width="100" show-overflow-tooltip ></el-table-column>
						<el-table-column label="组织机构代码" prop="organizationCode" min-width="100" show-overflow-tooltip ></el-table-column>
						<el-table-column label="所属区域" min-width="120" show-overflow-tooltip >
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}<span v-if="scope.row.areaName">{{ scope.row.areaName }}</span>
							</template>
						</el-table-column>
						<el-table-column label="排序号" prop="indexNo" min-width="80" show-overflow-tooltip ></el-table-column>
						<el-table-column label="操作" min-width="100" show-overflow-tooltip >
							<template slot-scope="scope">
								<span class="primary pointer mr15" @click="editUnitData(scope.row.id)">修改</span>
								<span class="primary pointer mr15" @click="deleteConfirm(scope.row.id)">删除</span>
								<span class="primary pointer mr15" @click="staffLink">人员管理</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			
				<div class="pagination" v-if="dataTabel.length">
					<nt-pagination ref="child" @fetchData="getUnitList"></nt-pagination>
				</div>
			</div>
		</div>
		<transition name="el-zoom-in-center">
			<detail v-if="detailShow" :unitData="unitData" @detailShowData="detailShowData" @getUnitList="getUnitList" ></detail>
		</transition>
	</div>
</template>

<script>
import NavTab from "@/components/navTab.vue"
import detail from "./detail"

export default {
	name: "list",
	components: {
		detail,
		NavTab,
	},
	data () {
		return {
			model: {
				organizationName: null,
				areaId: null,
				pageSize: 10,//每页记录数
				pageNo: 1,//页码
			},
			detailShow: false,
			dataTabel: [],
			multipleSelection: [],
			deleteId: [],
			idsVal: {
				ids: null
			},
			unitData: {},

			provinceCode: null,
			provinceList: [],
			cityCode: null,
			cityList: [],
			areaList: [],

		}
	},
	created() {
		this.getProvinceList();
	},
	mounted () {
		this.getUnitList();
		
	},
	methods: {
		// 新增浮层展开
		detailBox () {
			this.detailShow = true
			// 重置详情页数据
			this.unitData = {
				accidentNoPrefix: null,
				cityId: null,
				cityName: null,
				areaId: null,
				areaName: null,
				createId: null,
				createTime: null,
				desc: null,
				fullName: null,
				id: null,
				indexNo: null,
				organizationCode: null,
				provinceId: null,
				provinceName: null,
				simpName: null,
				stampUrl: null,
				isNew: true,
				trtcStatus: 0,
				bookingStatus: 1,
				payqrStatus: 0,
				pcCreateStatus: 0,
				sendSmsStatus: 0,
				allTimeModifyStatus: 0,
				halfBodyPhotoStatus: 0,
			}
		},
		detailShowData (val) {
			this.detailShow = val;
		},
		// 获取搜索列表
		getUnitList(args) {
			// 初始化分页
			this.model.page = 1;
			this.model.size = 10;
			if (args) {
				if (args.page) {//分页
					this.model.page = args.page;//当前页数
					this.model.size = args.pageSize;//每页显示多少条
				}
			}
			this.$axios.post('/admin/organization/list', this.model).then(res => {
				let data = this.AppUtils.checkResponse(res);
				if(data) {
					this.dataTabel = data.data.list;
					// 向分页组件传送数据
					if(this.dataTabel.length > 0) {
                        this.$nextTick(() => {
							this.$refs.child.initPage(data.data.total, this.model.page, this.model.size)
						})
                    }
				}
			})
		},
		// 获取省市区三联数据
		getProvinceList() {
			this.$axios.get(`/admin/organization/areaList/1/all`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
					this.provinceCode = parseFloat(data[0].areaCode);
					this.provinceList = data;
					this.getCityList(this.provinceCode);
				}
			})
		},
		getCityList(id) {
			this.$axios.get(`/admin/organization/areaList/2/${id}`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					// this.areaCode = data[0].areaCode;
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
					this.cityList = data;
				}
			})
		},
		getAreaList(id) {
			this.$axios.get(`/admin/organization/areaList/3/${id}`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
					let arr = [
                        {id: 0, areaName: "全部"}
                    ]
					this.areaList = arr.concat(data);
				}
			})
		},
		onSelectCity(e) {
			// console.log(e)
			this.model.areaId = null;
			this.cityCode = e;
			this.getAreaList(e);
		},

		// 修改
		editUnitData (val) {
			this.$axios.get('/admin/organization/detail/' + val).then(res => {
				let data = this.AppUtils.checkResponse(res);
				if (data) {
					this.unitData = data.data;
					this.detailShow = true;
					this.unitData.isNew = false;
					this.unitData.id = val;
				}
			})
		},
		// 获取选中表格id
		handleSelectionChange (val) {
			this.multipleSelection = val;
			this.deleteId = this.multipleSelection.map((item) => item.id);
		},
		// 删除条目
		deleteConfirm (val) {
			if (val.length <= 0) {
				return this.$message.error("请选中需要删除的数据");
			}
			if (Array.isArray(val)) {
				this.idsVal.ids = val.join(",");
			} else {
				this.idsVal.ids = val;
			}
			this.AppUtils.confirm('是否确认删除选中的数据？', () => {
				this.$axios.post('/admin/organization/delete', this.idsVal).then(res => {
					let data = this.AppUtils.checkResponse(res);
					if (data) {
						if (Array.isArray(val)) {
							this.multipleSelection.forEach((value, index) => {
								//遍历多选框获取的数据
								this.dataTabel.forEach((v, i) => {
									//遍历数据表，任意一个属性值相同，则说明该数据被选中，其i则为索引值
									if (value.id == v.id) {
										this.dataTabel.splice(i, 1);
									}
								})
							})
						} else {
							this.dataTabel.forEach((v, i) => {
								//遍历数据表，任意一个属性值相同，则说明该数据被选中，其i则为索引值
								if (val == v.id) {
									this.dataTabel.splice(i, 1);
								}
							})
						}
						this.getUnitList();
						this.$message.success("删除成功");
					}
				})
			}, () => {
				// 取消删除
			})
		},

		// 跳转到人员管理
		staffLink () {
			this.$router.push('/staff');
		},

		cellStyle ({ row, column, rowIndex, columnIndex }) {
			return "font-size:13px;";
		},
		tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
			if (rowIndex === 0) {
				return "height:50px; font-size:14px; background:#f4f5f7; color:#4a4a4a!important;";
			}
		},

	}
}
</script>

<style scoped lang="scss">
.mr15 {
  margin-right: 15px;
}

.select-wrap {
	padding-left: 20px;

	.date-box {
		width: 346px;
	}

	& > .group {
		margin-right: 50px;

		span.left {
			width: auto;
		}

		.el_box {
			width: 110px;
		}
	}

	.area {
		margin-left: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// list.vue?72eea8dc